// @module StellarGrade.ST_Facets.FacetsBrowseCategoryCell.View
define('StellarGrade.ST_Facets.FacetsBrowseCategoryCell.View', [
    'Facets.CategoryCell.View',
    'stellargrade_st_facets_facetsbrowsecategorycell.tpl',
    'underscore',
    'jQuery',
], function (FacetsBrowseCategoryCellView, stellargrade_st_facets_FacetsBrowseCategoryCell_tpl, _, $) {
    'use strict';

    return {
        loadModule: function () {
            _.extend(FacetsBrowseCategoryCellView.prototype, {
                template: stellargrade_st_facets_FacetsBrowseCategoryCell_tpl,
                getContext: _.wrap(FacetsBrowseCategoryCellView.prototype.getContext, function wrapper(fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    var parenturl = this.model.attributes.parenturl;
                    context.isPanelPc = false;
                    if (parenturl === '/PRODUCTS_CATEGORIES/PPC') {
                        context.isPanelPc = true;
                    } else if (parenturl === '/PRODUCTS_CATEGORIES/QuickShip') {
                        context.isQuickShip = true;
                    }

                    return context;
                }),
            });
        },
    };
});
